import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { DateCarouselSkeleton } from '../index';
import './DateCarousel.css';

const DateCarousel = ({ dates, dateItemsRef, scrollDates, selectedDate, onDateSelect, canScrollLeft, isLoading = false }) => {
    if (isLoading) {
        return <DateCarouselSkeleton />;
    }
    return (
        <div className="date-carousel-wrapper">
            <button
                onClick={() => canScrollLeft && scrollDates('left')}
                className={`date-scroll-btn ${!canScrollLeft ? 'disabled' : ''}`}
                disabled={!canScrollLeft}
            >
                <ChevronLeft size={20} />
            </button>

            <div
                ref={dateItemsRef}
                className="date-cards-container"
            >
                {dates.map((d, i) => {
                    const isSelected = selectedDate && d.fullDate.toDateString() === selectedDate.toDateString();
                    return (
                        <button
                            key={i}
                            disabled={d.isPast}
                            className={`date-card ${d.isPast ? 'past' : ''} ${isSelected ? 'active' : ''}`}
                            onClick={() => !d.isPast && onDateSelect(d.fullDate)}
                        >
                            <span className="date-text">{d.day}</span>
                            <span className="price-text">
                                {d.isPriceLoading ? (
                                    <span className="shimmer-bg price-shimmer"></span>
                                ) : (
                                    d.price
                                )}
                            </span>
                        </button>
                    );
                })}
            </div>

            <button
                onClick={() => scrollDates('right')}
                className="date-scroll-btn"
            >
                <ChevronRight size={20} />
            </button>
        </div>
    );
};

export default DateCarousel;
